import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import '../../styles/commoncomponents/toggleBar.scss';

function ToggleBar(props) {
    const [open, setOpen] = useState(props.openTab == "false" ? false : true);
    const cssClass = props.additionalClass ? (props.additionalClass + ' content') : 'content';
    return (
        <div className="barContainer">
            <div className="barHeader">
                <div className="headerLeft">
                    <h2><i className={`fa ${props.icon}`} style={{ color: `${props.color}` }} /> <span style={{ color: `${props.color}` }}>{props.caption}</span></h2>
                </div>
                {props.headerContent && (
                    <div className="headerCenter">
                        {props.headerContent}
                    </div>
                )}
                <div className="headerRight" hidden={props.type == "simple"}>
                    {
                        props.toggle == "off"
                            ? <span style={{ fontSize: '14px', color: '#777' }}>Last refreshed: {props.generated}</span>
                            :
                            <React.Fragment>
                                <i className={'fa fa-file-excel-o excel' + (!props.download ? ' hide' : '')} onClick={() => props.download()} ></i>
                                <i className={`fa ${open ? 'fa-minus-square-o' : 'fa-plus-square-o'} toggle`} onClick={() => setOpen(!open)} />
                            </React.Fragment>
                    }
                </div>
            </div>
            <Collapse in={open}>
                <div className="barContent" id="example-collapse-text">
                    <hr className="hrLine" />
                    <div className={cssClass}>
                        {props.content || props.children}
                    </div>
                </div>
            </Collapse>
        </div>
    )
}

export default ToggleBar
